import { newToolFilterOAuthMcp } from "../oauth.ts";

export const eanSearchMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.ean-search.org/apple-touch-icon.png",
  url: "https://www.ean-search.org/mcp",
  label: "EAN-Search.org",
});
